import { Head, Ring, CleanContent } from './ui';
import { metrics } from '../data';

export default function RankingCalculation() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="Algorithmic Precision" title="How Your Star Rank Is Calculated"
            text="Every eligible Shop Showcase receives a dynamic institutional reputation score from 0 to 100 based on verified business performance metrics" />
          <div className="row g-3 mb-3">
            <div className="col-lg-4">
              <div className="border border-line rounded-3 p-4 h-100 text-center">
                <div className="d-flex justify-content-center mb-2"><Ring value={84} /></div>
                <div className="h-md">Institutional Benchmark</div>
                <p className="p-sm mb-2">Algorithmic scoring resets rolling calculations continuously across verifiable customer actions and verification checkpoints</p>
                <span className="badge badge-star">Tier 8 Level</span>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row g-3">
                {metrics.map(([n, w, d]) => (
                  <div className="col-sm-6" key={n}>
                    <div className="border border-line rounded-3 p-3 h-100">
                      <div className="d-flex justify-content-between">
                        <span className="h-md">{n}</span><span className="text-blue fw-bold">{w}%</span>
                      </div>
                      <div className="bar-track rounded-pill my-2"><div className="bar-fill rounded-pill" style={{ width: `${w * 5}%` }} /></div>
                      <p className="p-sm mb-0">{d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-soft border border-line rounded-3 p-3 p-sm">
            <i className="bi bi-info-circle text-blue me-2" />
            <strong>Mandatory Gateways:</strong> A merchant cannot advance to higher Star ranks solely through score points. High star brackets require meeting strict minimum unique user thresholds, authentic evaluations, and direct corporate identity audits
          </div>
        </div>
      </section></CleanContent>
  );
}
